import {IconButton, Toolbar} from "@mui/material";
import clsx from "clsx";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import React from "react";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  title: {
    marginRight: theme.spacing(2),
  },
  spacer: {
    flexGrow: 1,
    paddingLeft: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
}));

export default function DashboardToolbar({title, titleContent, openDrawer, children, right}) {
  const classes = useStyles();

  return (
    <Toolbar>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={openDrawer}
        edge="start"
        className={clsx(
          classes.menuButton,
          {
            [classes.hide]: !openDrawer,
          },
        )}
        size="large">
        <MenuIcon/>
      </IconButton>
      {(title && !titleContent) ? (
        <Typography variant="h6" noWrap className={classes.title}>
          {title}
        </Typography>
      ) : null}
      {titleContent}
      {children}
      <div className={classes.spacer}/>
      {right}
    </Toolbar>
  );
}
